import React from "react";
import UserMessage from "./UserMessage";
import AssistantMessage from "./AssistantMessage";
import ErrorMessage from "./ErrorMessage";

/**
 * MessageBubble - Renders the appropriate message component based on role
 * @param {Object} message - The message object with role and content
 * @returns {JSX.Element|null}
 */
const MessageBubble = ({ message }) => {
    switch (message.role) {
        case "user":
            return <UserMessage message={message} />;
        case "assistant":
            return <AssistantMessage message={message} />;
        case "error":
            return <ErrorMessage message={message} />;
        default:
            return null;
    }
};

export default MessageBubble;
